import React, { useEffect, useState } from "react";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";

const NotificationTracking = () => {
  const [trackingData, setTrackingData] = useState([]);
  const [userId, setUserId] = useState(""); 
  const [searched, setSearched] = useState(false); 

  const Tracking = async (id) => {
    try {
      const val = { UserId: id || null };
      const res = await AddUpdate(
        "NotificationTracking/GetData_NotificationTracking",
        val
      );
      if (res?.data?.data) {
        const data = JSON.parse(res?.data?.data);
        const finaldata = data?.Table;
        setTrackingData(finaldata || []);
      } else {
        setTrackingData([]);
      }
    } catch (error) {
      console.log(error);
      setTrackingData([]);
    }
  };

  const columns = [
    { name: "User Id", selector: (row) => row.UserId || "-", sortable: true },
    { name: "Title", selector: (row) => row.Title, sortable: true },
    { name: "Message", selector: (row) => row.Message || "-", sortable: true },
    {
      name: "IsClicked",
      selector: (row) => (row.IsClicked ? "True" : "False"),
      sortable: true,
    },
    { name: "CreatedOn", selector: (row) => row.CreatedOn, sortable: true },
  ];

  const handleSearch = () => {
    setSearched(true);
    Tracking(userId); 
  };
  useEffect(()=>{
    Tracking()
  },[])

  return (
    <>
      <h2 style={{ color: "#f7931e", fontWeight: 700 }}>
        Notification Tracking
      </h2>


      <div style={{ marginBottom: "1rem" }}>
        <input
          type="text"
          placeholder="Enter User Id"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          style={{
            padding: "6px 10px",
            marginRight: "10px",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
        />
        <button
          onClick={handleSearch}
          style={{
            padding: "6px 12px",
            background: "#f7931e",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Search 
        </button>
      </div>

      <DataTable
        dense
        columns={columns}
        pagination
        data={trackingData}
        persistTableHead
        noDataComponent={
          searched ? "No data available" : " No all data available"
        }
        customStyles={customStyles}
      />
    </>
  );
};

export default NotificationTracking;
